module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-c0a51bea9b00e59fbee9857393f9dae0.png";